import { ApolloClient, InMemoryCache } from "@apollo/client";

const client = new ApolloClient({
  uri: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/rain-vesting/api",
  cache: new InMemoryCache(),
});

export default client;
